import { find } from 'lodash';

export const resolvePropertyGroups = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'propertyGroupService', propertyGroupService => {
    return propertyGroupService.findAll(page, perpage, deleted).then(list => list);
  }];
};

export const resolvePropertyGroup = (param = 'propertyGroup') => {
  return [ '$stateParams', 'propertyGroupService', ($stateParams, propertyGroupService) => {
    return $stateParams[param] && $stateParams[param] > 0 ? propertyGroupService.findById($stateParams[param]) : {};
  }];
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/resolvers/property.group.resolver.js